import { FC, ChangeEvent } from "react"
import styled from "styled-components"
import { Color as C } from "@lib/types"

import { ColorSwatch } from "@components/ui"
interface Props {
  colors: C[]
  state: any
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const ColorFilter: FC<Props> = ({ colors, onChange, state }) => {
  const filterState = state["color"]

  return (
    <StyledColorFilter>
      <Title>Color</Title>
      <CheckboxContainer>
        {colors.map(color => {
          return (
            <ColorSwatch
              key={color?.name}
              type="checkbox"
              color={color}
              onChange={onChange}
              isActive={filterState?.includes(color?.name)}
            />
          )
        })}
      </CheckboxContainer>
    </StyledColorFilter>
  )
}

const StyledColorFilter = styled.div``

const Title = styled.div`
  margin: 0 0 1.4rem;
  text-transform: uppercase;
  font-size: 1rem;
  line-height: 2.4rem;
  letter-spacing: 1.67px;
`

const CheckboxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-flow: row;
  grid-gap: 0.7rem;
`
